module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', {
    attrs: {
      "role": "primary"
    }
  }, [_c('section', {
    staticClass: "home-section section--1 row expanded align-middle align-right",
    style: ({
      height: (_vm.sectionHeight + "px")
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.showVid) ? _c('div', {
    staticClass: "mxr-video"
  }, [_c('div', {
    staticClass: "mxr-video__inner"
  }, [_c('video', {
    staticClass: "v-klnj",
    attrs: {
      "id": "vklnj"
    }
  }, [(_vm.videoSrc) ? _c('source', {
    attrs: {
      "src": _vm.videoSrc,
      "type": _vm.videoType
    }
  }) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mxr-video-sneak show-for-large",
    on: {
      "click": _vm.createVideo
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Voir la Vidéo")])]), _vm._v(" "), _c('div', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-scroll"
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      height: (_vm.sectionHeight + "px")
    }),
    attrs: {
      "id": "pinContainer"
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "section--hf row expanded align-middle collapse",
    style: ({
      height: (_vm.sectionHeight + "px")
    })
  }, [_c('div', {
    staticClass: "section--women small-12 medium-6 column text-center"
  }, [_c('router-link', {
    staticClass: "section__inner",
    attrs: {
      "to": "/looks/women"
    }
  }, [_c('div', {
    staticClass: "section__title"
  }, [_c('span', [_vm._v("Découvrir les looks")]), _vm._v(" "), _c('strong', [_vm._v("Femme")])]), _vm._v(" "), _c('div', {
    staticClass: "section__picture section--women__picture"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "section--men small-12 medium-6 column text-center"
  }, [_c('router-link', {
    staticClass: "section__inner",
    attrs: {
      "to": "/looks/men"
    }
  }, [_c('div', {
    staticClass: "section__title"
  }, [_c('span', [_vm._v("Découvrir les looks")]), _vm._v(" "), _c('strong', [_vm._v("Homme")])]), _vm._v(" "), _c('div', {
    staticClass: "section__picture section--men__picture"
  })])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('borders', {
    attrs: {
      "show-corners": !_vm.showVid,
      "show-text": true,
      "show-dots": true
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column shrink mxr-logo__wrap"
  }, [_c('img', {
    staticClass: "mxr-logo",
    attrs: {
      "src": require("../assets/img/mix-and-run.svg"),
      "width": "280",
      "alt": "Mix & Run",
      "id": "mxr-logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mxr-video-sneak__icon"
  }, [_c('i', {
    staticClass: "zmdi zmdi-play"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "storyContainer"
    }
  }, [_c('section', {
    staticClass: "panel panel--freedom"
  }, [_c('div', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel__picture"
  }, [_c('div', {
    staticClass: "filter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "word"
  }, [_c('span', [_vm._v("F")]), _vm._v(" "), _c('span', [_vm._v("r")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("d")]), _vm._v(" "), _c('span', [_vm._v("o")]), _vm._v(" "), _c('span', [_vm._v("m")])])]), _vm._v(" "), _c('section', {
    staticClass: "panel panel--happiness"
  }, [_c('div', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel__picture"
  }, [_c('div', {
    staticClass: "filter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "word"
  }, [_c('span', [_vm._v("H")]), _vm._v(" "), _c('span', [_vm._v("a")]), _vm._v(" "), _c('span', [_vm._v("p")]), _vm._v(" "), _c('span', [_vm._v("p")]), _vm._v(" "), _c('span', [_vm._v("i")]), _vm._v(" "), _c('span', [_vm._v("n")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("s")]), _vm._v(" "), _c('span', [_vm._v("s")])])]), _vm._v(" "), _c('section', {
    staticClass: "panel panel--achievement"
  }, [_c('div', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel__picture"
  }, [_c('div', {
    staticClass: "filter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "word"
  }, [_c('span', [_vm._v("A")]), _vm._v(" "), _c('span', [_vm._v("c")]), _vm._v(" "), _c('span', [_vm._v("h")]), _vm._v(" "), _c('span', [_vm._v("i")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("v")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("m")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("n")]), _vm._v(" "), _c('span', [_vm._v("t")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a97ab15e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 460
// module chunks = 1